import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const createTemplate = async (data) => {
  const res = await axiosInstance.post("/syllabus/template/create", data);
  return res.data;
};

export const getAllTemplates = async (filters = {}) => {
  const res = await axiosInstance.get("/syllabus/template/all", { params: filters });
  return res.data;
};

export const getTemplateById = async (id) => {
  const res = await axiosInstance.get(`/syllabus/template/${id}`);
  return res.data;
};

export const updateTemplate = async (id, data) => {
  const res = await axiosInstance.put(`/syllabus/template/update/${id}`, data);
  return res.data;
};

export const updateChapters = async (id, chapters) => {
  const res = await axiosInstance.put(`/syllabus/template/chapters/${id}`, { chapters });
  return res.data;
};

export const deleteTemplate = async (id) => {
  const res = await axiosInstance.delete(`/syllabus/template/delete/${id}`);
  return res.data;
};

export const getProgressOverview = async (templateId) => {
  const res = await axiosInstance.get(`/syllabus/progress/overview/${templateId}`);
  return res.data;
};

export const getSectionProgress = async (sectionId, subjectId = "") => {
  const res = await axiosInstance.get(`/syllabus/progress/${sectionId}`, {
    params: subjectId ? { subjectId } : {},
  });
  return res.data;
};